import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";

import useTable from "../components/useTable";
import Controls from "../components/controls/Controls";
import { Dimmer } from "../components/spinner";
// import { Select } from '../ui/inputs/Input'; // Eliminado, ya no se usa

import { TableBody, TableRow, TableCell, InputAdornment } from "@mui/material";

import axios from "axios";

const CatalogoProductosOc = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  // const cmbCampo = useRef(); // Eliminado
  const txtCriterio = useRef();

  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [activo, setActivo] = useState(true);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);

  const headCells = [
    {
      id: "codigo",
      label: "CÓDIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "DESCRIPCIÓN",
      width: "300px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "umidad",
      label: "UNIDAD DE MEDIDA",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idproducto.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.decripmedida.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const buscarProductos = () => {
    const campos = "p.idproducto, p.descripcion,u.descripcion as decripmedida ";
    const nomtab = `producto p inner join unidadmedida u on u.idunidadmedida = p.idunidadmedida`;
    const orden = "idproducto desc";
    const condi = `servicio = ${props.servicio}`
    const endpoint  = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;


    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      })
      .finally(() => {
        txtCriterio.current?.focus();
      });
  };
  const seleccionarRegistros = (condi, orden) => {
    let campos = "p.idproducto, p.descripcion, u.descripcion as decripmedida";
    let nomtab =
      "producto p INNER JOIN unidadmedida u ON u.idunidadmedida = p.idunidadmedida";

    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${encodeURIComponent(nomtab)}&orden=${orden}&condi=${encodeURIComponent(condi)}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }

        setActivate(false);
        txtCriterio.current.focus();
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
        txtCriterio.current.value = "";
        txtCriterio.current.focus();
      });
  };

  const seleccionarLista = (index) => (event) => {
    blanquear();

    props.onHideAceptaCatalogo(values);
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var idproducto = recordsAfterPagingAndSorting()[index].idproducto;

    setValues(idproducto);
  };

  // Función onChange eliminada ya que no había select para limpiar

  return (
    <Modal
      {...props}
      size="lg"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        buscarProductos();
        txtCriterio.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Seleccionar Producto.</h3>
        <a type="button" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 d-flex justify-content-between mx-auto m-0 p-0">
          <div className="input-group input-group-sm col-md-12">
            <input
              type="text"
              ref={txtCriterio}
              disabled={activate}
              placeholder="Ingrese criterio de búsqueda (Código, Descripción o Unidad)"
              onChange={handleSearch}
              className="form-control rounded-pill col-md-6 search-input"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.cedula}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "80px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.idproducto}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "150px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.decripmedida}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          onClick={seleccionarLista()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoProductosOc;
